import React from "react";
import "../styles/Projects.css";
import spotify from "../photos/spotify.png";
import google from "../photos/google.png";
import tiktok from "../photos/tiktok.png";
import amazon from "../photos/amazon.png";
import netflix from "../photos/netflix.png";
import whatsapp from "../photos/whatsapp.png";

function Projects() {
  return (
    <div className="projects">
      <div className="project">
        <img src={spotify} alt="" />
        <p className="project__decription">
          Clone Spotify Web Player. It includes user authentication with
          Spotify,playlists and songs from Spotify API ,React Hooks & Context
          API.(Code Available in my Github)
        </p>
      </div>

      <div className="project">
        <img src={google} alt="" />
        <p className="project__decription">
          Clone of Google.It includes Google API's for searching on web.
          Material UI for icons & custom hook called useGoogleSearch.(Code
          Available in my Github)
        </p>
      </div>

      <div className="project">
        <img src={amazon} alt="" />
        <p className="project__decription">
          Clone of Amazon Full Stack.It includes authentication with firebase
          and cloud functions to connect with Stripe Online Payment.(Code
          Available in my Github)
        </p>
      </div>

      <div className="project">
        <img src={netflix} alt="" />
        <p className="project__decription">
          Clone of Netflix.It includes TMDB API's and react-youtube for showing
          trailers.(Code Available in my Github)
        </p>
      </div>

      <div className="project">
        <img src={whatsapp} alt="" />
        <p className="project__decription">
          Clone of Whatsapp Web Full Stack.It includes Pusher as realtime
          database,Node.js & MongoDB for backend.(Code Available in my Github)
        </p>
      </div>

      <div className="project">
        <img src={tiktok} alt="" />
        <p className="project__decription">
          Clone of Tiktok Full Stack.It includes Node.js in backend.Express.js
          as a live server and MongoDB for database.It has snap scrolling
          behavior in the frontend.(Code Available in my Github)
        </p>
      </div>
    </div>
  );
}

export default Projects;
